/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

export const deleteCampaignPathSchema = z.object({ campaignId: z.string() });

export type DeleteCampaignInput = {
  path: z.input<typeof deleteCampaignPathSchema>;
  signal?: AbortSignal;
};

export async function deleteCampaign({
  path,
  signal,
}: DeleteCampaignInput): Promise<void> {
  const parsedPath = deleteCampaignPathSchema.parse(path);

  await socialApiClient.delete(`campaigns/${parsedPath.campaignId}`, {
    signal,
  });
}
